
import React from 'react';
import Script from 'react-load-script'; //https://www.npmjs.com/package/react-load-script
import Cookies from 'js-cookie' //https://www.npmjs.com/package/js-cookie

export default class GoogleAutoComplete extends React.Component
{
    constructor( props ) 
    {
        super( props );
    
        this.autocomplete = null;
    
        this.state = {
            scriptError: false,
            scriptLoaded: false,
            fieldsForState: {
                streetAddress: '',
                streetAddress2: '',
                locality: '',
                cityOrState: '',
                postalcode: '',
                country: '',
                keygroup: '',
                searchField: '',
            },
            names: {
                streetAddress: 'street1',
                streetAddress2: 'street2',
                locality: 'locality',
                cityOrState: 'citystate',
                postalcode: 'zipcode',
                country: 'country',
                keygroup: 'keygroup'
            },
            labels: {
                streetAddress: "Street Address",
                streetAddress2: "Street Address Line 2",
                locality: "City",
                postalcode: "Postal / Zip Code",
                cityOrState: "State / Province",
                country: "Country",
                keygroup: "Keygroup"
            },
            showResult: false,
            zipcode: Cookies.get('zipcode')
        };

        this.baseFields = this.state.fieldsForState;
    }

    shouldComponentUpdate( nextProps, nextState ) 
    {
        if ( ( this.state.scriptLoaded !== nextState.scriptLoaded ) && ( this.autocomplete === null ) ) 
        {
            this.autocomplete = new window.google.maps.places.Autocomplete((this.searchInput));
            this.autocomplete.addListener('place_changed', this.handleMapChange );
        }
        
        return true;
    }

    renderFields = () =>
    {
        return Object.keys(this.props.fields).map((key, index) => 
        {
            let inputvalue = this.state.fieldsForState[key];
            
            if(key === 'postalcode' && Cookies.get('zipcode') !== undefined)
            {
                inputvalue = Cookies.get('zipcode');
            }
            
            return (
                <div key={key} className={`address-field address-${key}`}>
                    <input type="text" id={'id'+index} name={this.state.names[key]} defaultValue={inputvalue}/>
                    <label htmlFor="this" >{this.state.labels[key]}</label>
                </div>
                )
            }
        )
    }

    handleOnFocus = () => 
    {
        this.searchInput.setAttribute('autoComplete', 'new-password');
    }

    handleSearchClear = (searchText) =>
    {       
        const { fieldsForState } = this.state;

        Object.keys(fieldsForState).map((key) => 
        {
            fieldsForState[key] = "";

            return true;
        })

        this.searchInput.value = '';
        
        this.setState ( { fieldsForState } );
    }

    handleMapChange = () =>
    {
        this.place = this.autocomplete.getPlace();
        const fieldsForState = { ...this.state.fieldsForState, ...this.baseFields };

        if( this.place.address_components )
        {
            const addrComps = this.place.address_components;

            var matchForStreet1 = this.place.adr_address ? this.place.adr_address.match(/<span class="street-address">(.*?)<\/span>/) : false;
            
            if( matchForStreet1 && matchForStreet1[1]) fieldsForState.streetAddress = matchForStreet1[1];
            
            const { fields } = this.props;
            
            Object.keys(addrComps).map((index) => 
            {
                const addrType = addrComps[index].types[0];

                switch (addrType) 
                {
                    case fields.locality: fieldsForState.locality = addrComps[index].long_name;
                    break;

                    case fields.cityOrState: fieldsForState.cityOrState = addrComps[index].long_name;
                    break;

                    case fields.country: fieldsForState.country = addrComps[index].long_name;
                    break;

                    case fields.postalcode: fieldsForState.postalcode = addrComps[index].long_name;
                    break;

                    default:
                }

                return true;
            });

            this.setState( {fieldsForState, showResult: true });
        }
    }

    handleScriptCreate() 
    {
        this.setState({ scriptLoaded: false })
    }

    handleScriptError() 
    {
        this.setState({ scriptError: true })
    }

    handleScriptLoad() 
    {
        this.setState({ scriptLoaded: true })
    }

    render()
    {
        const { scriptLoaded } = this.state;
        const { apiKey, id, placeholder } = this.props;
    
        return(

            [!scriptLoaded && <Script
            url= {`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`}
            onCreate={this.handleScriptCreate.bind(this)}
            onError={this.handleScriptError.bind(this)}
            onLoad={this.handleScriptLoad.bind(this)}
            />,
            <div className={`google-auto-complete ${this.state.showResult ? "showFields" : ""}`}>
                <div className="addressInput">
                    <input autoComplete="new-password" onFocus={this.handleOnFocus} onChange={this.props.resetError} type="text" id={ id } name={ id } placeholder={ placeholder } ref={ele=> { this.searchInput = ele; }}/>
                    <div className="clear" onClick={this.handleSearchClear} role="button" tabIndex="0" onKeyDown={this.handleSearchClear}><span>x</span></div>
                </div>
                <div className="addressFields">
                {this.renderFields()}
                </div>
            </div>
            ]
        )
    }
}

GoogleAutoComplete.defaultProps = 
{
    fields: {
        streetAddress: "route",
        streetAddress2: "administrative_level_4",
        locality: "locality",
        cityOrState: "administrative_area_level_1",
        postalcode: "postal_code",
        country: "country",
    }
}